import CashOut from '../../cards/cash-out';
import Occupancy from '../../cards/occupancy';
import CurrentLoan from '../../cards/refi-current-loan';
import RefiPurpose from '../../cards/refi-purpose';
import { SecondaryInvestmentAddress } from '../../cards/secondary-investment-address';
import { Branch, Card } from '../../components/deck';
import { PropertyTypeBranch } from './property-type';
import { RefiStateVerification } from './state-verification';

export default (continuation) =>
  RefiStateVerification(
    PropertyTypeBranch(
      Card(
        Occupancy,
        Branch(
          {
            SecondaryInvestmentAddress: Card(SecondaryInvestmentAddress)
          },
          ({ model }) => {
            const occupancy = model.getIn(['loan', 'occupancy']);
            const cardIndex = 'SecondaryInvestmentAddress';
            if (occupancy === 'SecondHome' || occupancy === 'InvestmentProperty') {
              return cardIndex;
            } else {
              return '';
            }
          },
          Card(
            RefiPurpose,
            Branch(
              {
                CashOut: Card(CashOut)
              },
              ({ model }) => model.getIn(['loan', 'refiPurpose']),
              Card(CurrentLoan, continuation)
            )
          )
        )
      )
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/refinance.js